/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import { Box, Container, Divider, Grid, Stack, Typography, styled } from '@mui/material';
import Image from '../../components/Image';
import useLocales from '../../hooks/useLocales';
import { useSelector } from '../../redux/store';
// import { useRollingNumberTick } from '../../hooks/useRollingNumber';

const FooterText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: 700,
  fontSize: '.7rem',
}));

const SocialIcons = styled(Image)(({ theme }) => ({
  width: 24,
  height: 24,
  cursor: 'pointer',
}));

const FooterBannerText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '1rem',
  textAlign: 'center',
  paddingLeft: '2rem',
  paddingRight: '2rem',
  textShadow: '2px 2px 1px black',
  fontWeight: 500,
  [theme.breakpoints.up('sm')]: {
    fontSize: 18,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5vw',
  },
}));

const FooterIconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  // alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column',
  marginBottom: '2rem',
}));

const CustomDivider = styled(Divider)(({ theme }) => ({
  margin: '1rem 0px',
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));

const JackpotBox = styled(Grid)(({ theme }) => ({
  paddingLeft: '3%',
  paddingRight: '3%',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  margin: 0,
  alignItems: 'flex-end',
  position: 'absolute',
  bottom: '10%',
}));

const PrizeBox = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const PrizeText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '35%',
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    top: '40%',
    fontSize: 25,
  },
  [theme.breakpoints.down('sm')]: {
    top: '42%',
    fontSize: 14,
  },
}));

const Footer = () => {
  const { translate } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  // const min = useRollingNumberTick({
  //   from: 1353.21,
  //   to: 100000.5,
  //   step: 0.01, // <-- increment by 0.01
  //   interval: 100, // <-- every 1 second
  //   precision: 2,
  // });

  // const major = useRollingNumberTick({ from: 11332.02, to: 1133200.0, step: 0.01, interval: 15, precision: 2 });

  // const grand = useRollingNumberTick({ from: 141603.0, to: 14160300.0, step: 0.01, interval: 5, precision: 2 });

  // const format = (num) =>
  //   new Intl.NumberFormat('en-US', {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   }).format(num);

  const {
    config_footer_copyright,
    // config_name,
    config_youtube,
    config_whatsapp,
    config_wechat,
    config_viber,
    config_twitter,
    config_telegram,
    config_messenger,
    config_line,
    config_instagram,
    config_facebook,
  } = siteSettings || {};

  const onOpenSocial = (link) => {
    window.open(link, '_blank');
  };

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Container
        maxWidth="lg"
        sx={{
          backgroundColor: '#003C79',
          py: '0px !important',
          px: '0px !important',
        }}
      >
        {/* <Box sx={{ position: 'relative' }}>
          <Image src={require('../../assets/jackpot/jackpot_background_en.png')} />
          <JackpotBox container>
            <PrizeBox item md={3} sm={3} xs={3}>
              <Image src={require('../../assets/jackpot/mini_box.png')} />
              <PrizeText>{format(min)}</PrizeText>
            </PrizeBox>
            <PrizeBox item md={4} sm={4} xs={4}>
              <Image src={require('../../assets/jackpot/grand_box.png')} />
              <PrizeText>{format(grand)}</PrizeText>
            </PrizeBox>
            <PrizeBox item md={3} sm={3} xs={3}>
              <Image src={require('../../assets/jackpot/major_box.png')} />
              <PrizeText>{format(major)}</PrizeText>
            </PrizeBox>
          </JackpotBox>
        </Box> */}
        <Box sx={{ position: 'relative' }}>
          <Image src={require('../../assets/home/footer_banner.webp')} />
          <FooterBannerText>{translate('footer_banner_desc')}</FooterBannerText>
        </Box>

        <Box sx={{ background: '#003C79', p: '2rem' }}>
          <Stack alignItems="center">
            <Typography sx={{ fontSize: '15px' }}>{translate('official_partner_of')}</Typography>
            <Image
              src={require('../../assets/home/one_championship.png')}
              sx={{ width: '65px', height: '50px', mt: '5px' }}
            />

            {/* <Typography sx={{ fontSize: '15px', mt: '2rem' }}>{translate('payment')}</Typography>
            <Image
              src={require('../../assets/home/local_bank_transfer.png')}
              sx={{ width: '90px', height: '22px', mt: '15px' }}
            />
            <Image src={require('../../assets/home/luckypay.png')} sx={{ width: '44px', height: '38px', mt: '15px' }} />
            <Image src={require('../../assets/home/direpay.png')} sx={{ width: '95px', height: '34px', mt: '15px' }} />
            <Image src={require('../../assets/home/gdpay.png')} sx={{ width: '100px', height: '34px', mt: '15px' }} /> */}
          </Stack>
        </Box>

        <Box
          sx={{
            m: '0px 1rem 1rem',
            p: { md: '2rem 1rem', sm: 0, xs: 0 },
            borderTop: { md: '1px dashed #fff', sm: 'unset', xs: 'unset' },
            borderBottom: { md: '1px dashed #fff', sm: 'unset', xs: 'unset' },
          }}
        >
          <CustomDivider />
          <Grid container spacing={1.5}>
            <Grid
              item
              md={6.5}
              sm={12}
              xs={12}
              sx={{ pl: 2, borderRight: { md: '1px dashed #fff', sm: 'unset', xs: 'unset' } }}
            >
              <Stack spacing={1} sx={{ px: { md: 2, sm: 0, xs: 0 } }}>
                <FooterText>{translate('gaming_license')}</FooterText>
                <Stack direction="row" spacing={1} sx={{ cursor: 'pointer', alignItems: 'center' }}>
                  <Image src={require('../../assets/footer/footer-anjouan.webp')} sx={{ cursor: 'pointer' }} />
                  <Typography sx={{ fontSize: { md: '12px', sm: '10px', xs: '10px' }, color: '#fff' }}>
                    {translate('gaming_license_desc')}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid
              item
              md={3.5}
              sm={12}
              xs={12}
              sx={{ pl: 2, borderRight: { md: '1px dashed #fff', sm: 'unset', xs: 'unset' } }}
            >
              <CustomDivider />
              <Stack spacing={1} sx={{ px: { md: 2, sm: 0, xs: 0 } }}>
                <FooterText>{translate('payment_methods')}</FooterText>
                <Stack direction={'row'} spacing={1}>
                  <Image
                    src={require('../../assets/footer/bkash.png')}
                    sx={{ height: '30px', width: 'auto', borderRadius: '3px' }}
                  />
                  <Image
                    src={require('../../assets/footer/nagad.png')}
                    sx={{ height: '30px', width: 'auto', borderRadius: '3px' }}
                  />
                  <Image
                    src={require('../../assets/footer/rocket.png')}
                    sx={{ height: '30px', width: 'auto', borderRadius: '3px' }}
                  />
                  {/* <Image
                    src={require('../../assets/footer/upay.png')}
                    sx={{ height: '30px', width: 'auto', borderRadius: '3px' }}
                  /> */}
                </Stack>
              </Stack>
            </Grid>
            <Grid item md={2} sm={12} xs={12}>
              <CustomDivider />
              <FooterIconBox sx={{ px: { md: 2, sm: 0, xs: 0 } }}>
                <FooterText>{translate('follow_us')}</FooterText>
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                  {!!config_youtube && (
                    <Box onClick={() => onOpenSocial(config_youtube)}>
                      <SocialIcons src={require('../../assets/social/yt.png')} />
                    </Box>
                  )}

                  {!!config_facebook && (
                    <Box onClick={() => onOpenSocial(config_facebook)}>
                      <SocialIcons src={require('../../assets/social/fb.png')} />
                    </Box>
                  )}

                  {!!config_instagram && (
                    <Box onClick={() => onOpenSocial(config_instagram)}>
                      <SocialIcons src={require('../../assets/social/instagram.png')} />
                    </Box>
                  )}

                  {!!config_whatsapp && (
                    <Box onClick={() => onOpenSocial(config_whatsapp)}>
                      <SocialIcons src={require('../../assets/social/wa.png')} />
                    </Box>
                  )}

                  {!!config_wechat && (
                    <Box onClick={() => onOpenSocial(config_wechat)}>
                      <SocialIcons src={require('../../assets/social/wechat.png')} />
                    </Box>
                  )}

                  {!!config_viber && (
                    <Box onClick={() => onOpenSocial(config_viber)}>
                      <SocialIcons src={require('../../assets/social/viber.png')} />
                    </Box>
                  )}

                  {!!config_twitter && (
                    <Box onClick={() => onOpenSocial(config_twitter)}>
                      <SocialIcons src={require('../../assets/social/twitter.png')} />
                    </Box>
                  )}

                  {!!config_telegram && (
                    <Box onClick={() => onOpenSocial(config_telegram)}>
                      <SocialIcons src={require('../../assets/social/telegram.png')} />
                    </Box>
                  )}

                  {!!config_messenger && (
                    <Box onClick={() => onOpenSocial(config_messenger)}>
                      <SocialIcons src={require('../../assets/social/messenger.png')} />
                    </Box>
                  )}

                  {!!config_line && (
                    <Box onClick={() => onOpenSocial(config_line)}>
                      <SocialIcons src={require('../../assets/social/line.png')} />
                    </Box>
                  )}
                </Box>
              </FooterIconBox>
            </Grid>
          </Grid>
          <CustomDivider sx={{ m: 0 }} />
        </Box>
        <Box sx={{ background: '#003C79', p: '1rem', borderTop: '2rem solid #012951' }}>
          <Typography sx={{ fontWeight: 900, fontSize: '20px' }}>{translate('site_description')}</Typography>
          <ul
            style={{
              marginLeft: 18,
            }}
          >
            <li style={{ marginTop: '15px', lineHeight: 'normal' }}>{translate('site_description_1')}</li>
            <li style={{ marginTop: '15px', lineHeight: 'normal' }}>{translate('site_description_2')}</li>
            <li style={{ marginTop: '15px', lineHeight: 'normal' }}>{translate('site_description_3')}</li>
            <li style={{ marginTop: '15px', lineHeight: 'normal' }}>{translate('site_description_4')}</li>
            <li style={{ marginTop: '15px', lineHeight: 'normal' }}>{translate('site_description_5')}</li>
            <li style={{ marginTop: '15px', lineHeight: 'normal' }}>{translate('site_description_6')}</li>
          </ul>
        </Box>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: '#F0C335',
            textAlign: 'center',
            pt: '10rem',
            pb: { md: '2rem', sm: '8rem', xs: '80px' },
          }}
        >
          {config_footer_copyright}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
